import { Pay } from 'containers/Pay'

export default Pay
